<template>
  <div class="pagination">
    <NuxtLink
      v-if="pageInfo.prevPage"
      :to="`?page=${pageInfo.prevPage}`"
      class="page-link"
    >
      <svg
        width="5"
        height="7"
        viewBox="0 0 5 7"
      >
        <path
          d="M3.72009 6.75L4.6543 5.8319L2.53588 3.75L4.6543 1.6681L3.72009 0.75L0.654297 3.75L3.72009 6.75Z"
          fill="#B1B1B1"
        />
      </svg>
    </NuxtLink>
    <template v-for="(item, key) in visiblePageLinks">
      <NuxtLink
        v-if="item"
        :key="key"
        :to="`?page=${item}`"
        :class="{ selected: Number(pageInfo.currentPage) === Number(item) }"
        class="page-link"
      >
        {{ item }}
      </NuxtLink>
      <div
        v-else
        :key="`${key}dots`"
        class="page-link-dots"
      >...</div>
    </template>

    <NuxtLink
      v-if="pageInfo.nextPage"
      :to="`?page=${pageInfo.nextPage}`"
      class="page-link"
    >
      <svg
        width="5"
        height="7"
        viewBox="0 0 5 7"
      >
        <path
          d="M1.58851 6.75L0.654297 5.8319L2.77272 3.75L0.654297 1.6681L1.58851 0.75L4.6543 3.75L1.58851 6.75Z"
          fill="#B1B1B1"
        />
      </svg>
    </NuxtLink>
  </div>
</template>

<script>
export default {
  props: {
    pageInfo: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    visiblePageLinks () {
      const arrLinks = [
        ...new Set([
          1,
          this.pageInfo.prevPage,
          this.pageInfo.currentPage,
          this.pageInfo.nextPage,
          this.pageInfo.totalPages,
        ]),
      ].filter(item => item !== null)
      if (this.pageInfo.currentPage > 3) {
        arrLinks.splice(1, 0, null)
      }
      if (this.pageInfo.totalPages > this.pageInfo.currentPage + 2) {
        arrLinks.splice(arrLinks.length - 1, 0, null)
      }
      return arrLinks
    },
  },
}
</script>

<style lang="sass" scoped>
  .pagination
    @apply flex flex-row justify-center items-center space-x-4 my-4
    .page-link,
    .page-link-dots
      @apply w-7 h-7 border flex justify-center items-center cursor-pointer bg-white text-gray-400 select-none text-xs
      border-color: #DDDDDD
      border-radius: 3px
    .page-link
      &:hover
        @apply bg-gray-300

      &:active
        @apply bg-gray-200

      &.selected
        @apply bg-gray-900
    .page-link-dots
      @apply cursor-default
</style>
